export default "__VITE_ASSET__CCEd1rHi__"